import { DialogHeader } from '@indeed/ifl-components'

export default DialogHeader
